import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useTextInput, { TextInput } from "@/components/form/text-input";

const S15 = (props) => {
    const text = useTextInput({
        name: "info[miscellaneous][description]",
        label: "Er det noe mer du ønsker å legge til som vi bør vite?",
        placeholder: "Skriv her...",
        required: false,
        ...props,
    })

    return (
        <Wrapper {...props} header="Og helt til slutt">
            <TextInput {...text.props}/>
        </Wrapper>
    );
};

export default S15;
